import $ from 'jquery';

import 'jquery.mmenu';
import ieDetector from './ieDetector';
ieDetector();

import { initializeMap } from './map';
import { initializePrecipitationChart, initializeChartSwitcher } from './charts';

$(document).ready(function() {
  /* Hamburger Menu */
  $('#mobileMenu').mmenu();

  /* Tabs */
  $('ul.tabLinks li').on('click', function() {
    const CLASS_NAME = 'current';
    const TAB_ID = $(this).attr('data-tab');

    $('ul.tabLinks li').removeClass(CLASS_NAME);
    $('.tabPanel').removeClass(CLASS_NAME);

    $(this).addClass(CLASS_NAME);
    $(`#${TAB_ID}`).addClass(CLASS_NAME);
  });

  /* Map Legend Toggle Button */
  $('#toggleLegend').click(function() {
    $('.mapLegend ul').fadeToggle('slow');
  });

  /* Lightbox */
  $('.lightGallery').lightGallery({
    selector: '.lightBoxItem',
    download: false,
  });

  initializeMap();
  initializeChartSwitcher();
  initializePrecipitationChart();
});



// WEBPACK FOOTER //
// ./theme_src/js/haflbs.js